import useDefinedContext from "hooks/useDefinedContext";
import TooltipStoreContext from "../contexts/TooltipStoreContext";

interface UseTooltipProps {}

function useTooltip(props?: UseTooltipProps) {
  return useDefinedContext(TooltipStoreContext);
}

export default useTooltip;
